import {httpPostJson} from "../helpers/http";
import {SendMessageRequestModel} from "../types/SendMessageRequestModel";

export const sendMessage = (
    request: SendMessageRequestModel
): Promise<Response> => {
    return httpPostJson(`/api/v1/messages/send`, JSON.stringify(request));
};